export const getProductSlug = (product) => {
  // Example value of process.env.PRODUCT_SLUG_MAPPING:
  // {
  //   "fanshield": 'TGFS',
  //   "shopgurantee": 'SHOP',
  //   "raas": 'RAAS',
  // }
  const productSlugMap = JSON.parse(
    process.env.VUE_APP_PRODUCT_SLUG_MAPPING || '',
  ) || {
    product: '',
  };

  return productSlugMap[product];
};

const getKeyByValue = (object, value) => Object.keys(object)
  .find(key => object[key] === value);

export const getProductFromProductSlug = (productSlug) => {
  const productSlugMap = JSON.parse(
    process.env.VUE_APP_PRODUCT_SLUG_MAPPING || '',
  ) || {
    product: '',
  };

  return getKeyByValue(productSlugMap, productSlug);
};
